import { ReactComponent as InfoIcon } from "@common/assets/images/sidebar-icons/info-module.svg";
import { vars } from "@common/styles";
import styled from "styled-components";

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: left;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    border-radius: 0.5rem;
    background-color: ${vars.colors.black} !important;
    opacity: 1 !important;
    z-index: 1;
  }

  p {
    background: linear-gradient(to right, ${vars.colors.orange}, ${vars.colors.sky}, ${vars.colors.green});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  a {
    text-decoration: underline;
    font-weight: bold;
  }
`;

export const StyledInfoIcon = styled(InfoIcon)`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  path {
    stroke: ${vars.colors.orange};
  }
`;
